import React from "react";
import { useSelector, useDispatch } from "react-redux";

import { ProjectId } from "../../../backend/model";
import { AppDispatch } from "../../../store";

import {
  kRegProjectDetailsActions,
  kRegProjectDetailsSelectors,
} from "../../../store/kRegProjectDetailsSlice";
import { ColumnSpecGrid } from "./column-spec-grid";

interface ColumnSpecProps {
  id: ProjectId;
}

export const ProjectColumnSpecPage: React.FunctionComponent<
  ColumnSpecProps
> = ({ id }) => {
  const dispatch: AppDispatch = useDispatch();

  const mapData = useSelector(kRegProjectDetailsSelectors.selectMapData);
  const updateRef = useSelector(
    kRegProjectDetailsSelectors.selectColumnStatusRef(),
  );

  const dataLoading = useSelector(
    kRegProjectDetailsSelectors.selectByIdRequestPending(id),
  );

  const doRefresh = () => {
    dispatch(
      kRegProjectDetailsActions.getUpdate(
        id,
        updateRef ? updateRef : undefined,
      ),
    ).catch(() => {});
  };

  return (
    <div className="kserv-content">
      <ColumnSpecGrid
        project_id={id}
        mapData={mapData}
        onRefresh={doRefresh}
        dataLoading={dataLoading || false}
      />
    </div>
  );
};
